module.exports = __webpack_public_path__ + "static/media/lobby-card-help-desk.e7da85b3.svg";